import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Form from "../../components/form/Form";
import { getErrorToastMessage } from "../../utils/httpToast";

const AddCandidatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goCandidatesWithToast = (type, message) => {
    navigate("/candidates", { state: { toast: { type, message } } });
  };

  const handleSaveSuccess = () => {
    goCandidatesWithToast("success", t("MODAL.SUCCESSFUL"));
  };

  const handleSaveError = (err) => {
    goCandidatesWithToast("error", getErrorToastMessage(err, t));
  };

  return (
    <div className=" min-h-screen bg-lightGray flex justify-center py-10 px-4">
        <div className="w-full max-w-2xl bg-white rounded-xl shadow-sm p-8 md:p-10 h-fit">
           <Form onSaveSuccess={handleSaveSuccess} onSaveError={handleSaveError} />
        </div>
    </div>
  );
};

export default AddCandidatePage;